import { ComponentType, useEffect } from "react";
import { useAds } from "src/hooks/useAds";

export function withAdsDisabled<P extends object>(Component: ComponentType<P>) {
  return (props: P) => {
    const { setAdsEnabled } = useAds();

    useEffect(() => {
      setAdsEnabled(false);

      // turn ads back on on unmount. let the next page
      // turn them off if necessary.
      return () => setAdsEnabled(true);
    }, [setAdsEnabled]);

    return <Component {...props} />;
  };
}
